module.exports = __webpack_public_path__ + "static/restaurant-manager-job-description-4edd6baa080f8156e6a030986fd3a93b.jpg";